<template>
  <div class="tooltip-group" ref="tooltipGroupRef">
    <v-btn>
      <i class="ico-info"></i>
      <v-tooltip
        v-model="tooltipVisible"
        activator="parent"
        location="top start"
        :open-on-hover="!isMobile"
        :open-on-click="isMobile"
      >
        {{ TooltipText }}
      </v-tooltip>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps<{ TooltipText: string }>()

const tooltipVisible = ref(false)
const isMobile = ref(false)
const tooltipGroupRef = ref<HTMLElement | null>(null)

const checkDevice = () => {
  isMobile.value = window.innerWidth <= 768
}

const handleOutsideClick = (e: MouseEvent) => {
  if (!isMobile.value || !tooltipVisible.value) return
  if (
    tooltipGroupRef.value &&
    !tooltipGroupRef.value.contains(e.target as Node)
  ) {
    tooltipVisible.value = false
  }
}

onMounted(() => {
  checkDevice()
  window.addEventListener('resize', checkDevice)
  document.addEventListener('click', handleOutsideClick)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkDevice)
  document.removeEventListener('click', handleOutsideClick)
})
</script>


<style setup lang="scss">
.tooltip-group{
  display:inline-block;
  button{
    padding:0;
    box-shadow:none;
    min-width:2.4rem;
  }
  .v-btn.v-btn--density-default{
    height:2.4rem
  }
  .v-btn--elevated:hover,
  .v-btn--elevated:focus{
    box-shadow:none
  }
  .v-btn--variant-elevated,
  .v-btn--variant-flat{
    border-radius:100%;
    background:transparent;
  }
  .ico-info{
    ///margin-left:.6rem;
    position:relative;
    width:2rem;
    height:2rem;
    background:url("@/assets/img/ico-info.svg") center no-repeat;
    background-size:2.4rem auto;
  }

}
.v-overlay.v-tooltip{
  .v-overlay__content{
    font-size:1.3rem !important;
    padding: .9rem 1.4rem;

  }
}
</style>
